import { EntityModel } from '@/interfaces'
import {
  ALL_EXTENSION_MAP_ITEMS_QUERY,
  CREATE_EXTENSION_MAP_ITEM_MUTATION,
  DELETE_EXTENSION_MAP_ITEM_MUTATION,
  FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION,
  SINGLE_EXTENSION_MAP_ITEM_QUERY,
  UPDATE_EXTENSION_MAP_ITEM_MUTATION,
} from './graphql'
import ratioAccommodationEntity from '@/entities/ratioAccommodation/entity'
import ratioExtensionAccommodationEntity from '@/entities/ratioExtensionAccommodation/entity'

const ratioAccommodationExtensionMapItemModel: EntityModel = {
  name: 'extensionMapItem',
  namePlural: 'extensionMapItems',
  uniqueName: 'ratioAccommodationExtensionMapItem',
  uniqueNamePlural: 'ratioAccommodationExtensionMapItems',
  path: 'travel/pricing/adaptors/ratio/extension_map_item',
  baseUrl: '/travel/pricing/adaptors/ratio/extension_map_items',
  translationPrefix: 'entities:ratioAccommodationExtensionMapItem.',
  getDisplayName: (values: any) => {
    return 'Accommodation Extension Map Item'
  },
  gql: {
    getAll: ALL_EXTENSION_MAP_ITEMS_QUERY,
    getSingle: SINGLE_EXTENSION_MAP_ITEM_QUERY,
    create: CREATE_EXTENSION_MAP_ITEM_MUTATION,
    update: UPDATE_EXTENSION_MAP_ITEM_MUTATION,
    delete: DELETE_EXTENSION_MAP_ITEM_MUTATION,
    forceDelete: FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION,
  },
  attributes: {
    baseAccommodation: {
      name: 'baseAccommodation',
      label: 'entities:ratioAccommodationExtensionMapItem.attributes.baseAccommodation.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioAccommodationEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    extensionAccommodation: {
      name: 'extensionAccommodation',
      label: 'entities:ratioAccommodationExtensionMapItem.attributes.extensionAccommodation.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioExtensionAccommodationEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioAccommodationExtensionMapItemModel
